export const Menu = [
    {
        title: "About",
        section: "about",
        disabled: false,
        PolishLang: {
            title: "Trochę o mnie"
        }
    },
    {
        title: "What I Use",
        section: "use",
        disabled: false,
        PolishLang: {
            title: "Co używam..."
        },
        react: {
            title: "Why I use React ?",
            href: "react",
            style: "Blue",
            disabled: false,
            PolishLang: {
                title: "Dlaczego używam React ?"
            }
        }
    },
    {
        title: "Projects",
        section: "projects",
        style: "Green",
        disabled: false,
        PolishLang: {
            title: "Projekty"
        }
    },
    {
        title: "My Github",
        href: "https://github.com/pavdevuk",
        disabled: false,
        target: "_blank",
        PolishLang: {
            title: "Mój GitHub"
        }
    },
    {
        title: "CV",
        href: "/cv",
        disabled: false,
        target: "_blank"
    },
    {
        title: "Contact",
        section: "contact",
        disabled: true,
        PolishLang: {
            title: "Kontakt"
        }
    }
]